import { render, staticRenderFns } from "./NormalRed.vue?vue&type=template&id=5322c4d8&scoped=true"
import script from "./NormalRed.vue?vue&type=script&lang=js"
export * from "./NormalRed.vue?vue&type=script&lang=js"
import style0 from "./NormalRed.vue?vue&type=style&index=0&id=5322c4d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322c4d8",
  null
  
)

export default component.exports